import { render, staticRenderFns } from "./NakesList.vue?vue&type=template&id=72776348"
import script from "./NakesList.vue?vue&type=script&lang=js"
export * from "./NakesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports